import { Result, Table } from 'antd'
import React from 'react'
import { staffColumns } from '../../constants/tableColumns/staff'
import get from "lodash/get";
import StaffFilters from './staffFilters';

const StaffTable = ({toggleStaffModal,staffs,showEmpty,setStaff, inputRef,config, getCompanyStaff, filter}) => {
  return (
        <div className="h-full rounded-xl overflow-hidden bg-white flex-1 overflow-y-auto scrollbar-hidden pb-5 min-w-full ">
            {get(staffs, "data.length") > 0 && (
                <StaffFilters toggleStaffModal={toggleStaffModal} staffs={staffs} inputRef={inputRef} config={config} setStaff={setStaff} getCompanyStaff={getCompanyStaff} filter={filter}  />
              )}
            <div className="overflow-y-auto">
              {get(staffs, "data.length") > 0 && (
                <Table
                  columns={staffColumns(toggleStaffModal,config)}
                  dataSource={get(staffs, "filtered", get(staffs, "data"))}
                  size="small"
                 rowKey={(record) => get(record, "id") || crypto.randomUUID()}
                />
              )}
              {showEmpty && (
                <div >
                  <Result
                    title={`No Staff exists...!`}
                    subTitle="Please try again with another company."
                    status="404"
                  />
                </div>
              )}
            </div>
          </div>
  )
}
export default StaffTable